import ReactGA from 'react-ga';

export const initGA = (codeGA) => {       
    ReactGA.initialize(codeGA);
} 

// Tracking PageViews
export const GApageView = (page) => {   
    ReactGA.pageview(page);   
}

// Tracking Events
export const GAevent = (categoryName, eventName) => {
    ReactGA.event({       
        category: categoryName,  // Required
        action: eventName,       // Required
        label: 'labelName',       
        value: 10,       
        nonInteraction: false     
    });   
}


// Tracking Load/Render Performance
export const GAtiming = (categoryName, variableName, valueNum) => {
    ReactGA.timing({       
        category: categoryName,       
        variable: variableName,       
        value: valueNum
    });
};


// Tracking Exception
export const GAexception = (detail) => {
    ReactGA.exception({ description: detail });
};